import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Notifications } from 'virtues-bootstrap';
// comment
import Header from 'containers/Header';
import AppRouter from 'router/AppRouter';
import AppLoading from 'containers/AppLoading';
import Login from 'containers/Login';
import NotFound from 'components/NotFound';
import PrivacyPolicy from 'components/PrivacyPolicy';
import TokenExpired from 'components/TokenExpired';
import DeleteReport from 'components/DeleteReport';
import UserLicenseAgreementPopup from 'components/UserLicenseAgreementPopup';

const App = ({ history }) => (
  <AppLoading>
    <ConnectedRouter history={history}>
      <>
        <Header />
        <Switch>
          <Route path="/404" component={NotFound} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/" component={AppRouter} />
        </Switch>
        <Notifications />
        <TokenExpired />
        <DeleteReport />
        <UserLicenseAgreementPopup />
      </>
    </ConnectedRouter>
  </AppLoading>
);

App.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default App;

